import { render, staticRenderFns } from "./tongxinMap.vue?vue&type=template&id=7c484137&scoped=true&"
import script from "./tongxinMap.vue?vue&type=script&lang=js&"
export * from "./tongxinMap.vue?vue&type=script&lang=js&"
import style0 from "./tongxinMap.vue?vue&type=style&index=0&id=7c484137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c484137",
  null
  
)

component.options.__file = "tongxinMap.vue"
export default component.exports